// src/utils/album/imageLoader.js
export const loadImageToBase64 = async (url) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error(`Erro ao carregar imagem: ${url}`, error);
        return null;
    }
};

export const loadAllImagesAsBase64 = async (images) => {
    const loadedImages = await Promise.all(
        images.map(async (image) => {
            const base64 = await loadImageToBase64(image.generated_image_url);
            return {
                ...image,
                base64: base64
            };
        })
    );
    
    return loadedImages;
};